import { DeskMail } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const MailToolkitObject = registerToolkitObjectType<DeskMail>('mail');
